[
  {
    "id": "mx-redlara-244",
    "name": "Advanced Fertility Center Cancun",
    "address": {
      "id": "addr-mx-redlara-244",
      "address1": "Av. Tulum, Lote 3, manzana 1, super manzana 9, Planta Baja",
      "address2": null,
      "city": "Cancún",
      "state": "QROO",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Advanced Fertility Center Cancun",
    "images": [
      {
        "id": "mx-redlara-244-image-1",
        "url": "https://www.fertilitycentercancun.com.mx/clinic-labs.jpg",
        "name": "Fertility Center Cancun Laboratory object-cover w-full h-full hover:scale-105 transition-transform duration-1000"
      },
      {
        "id": "mx-redlara-244-image-2",
        "url": "https://www.fertilitycentercancun.com.mx/lab.png",
        "name": "Background Tile object-cover"
      },
      {
        "id": "mx-redlara-244-image-3",
        "url": "https://www.fertilitycentercancun.com.mx/medical-team.jpg",
        "name": "Fertility Center Cancun Medical Team object-cover transition-transform duration-700 group-hover:scale-105"
      },
      {
        "id": "mx-redlara-244-image-4",
        "url": "https://www.fertilitycentercancun.com.mx/images/treatments/ivf-portada.png",
        "name": "IVF (In Vitro Fertilization) w-full h-full object-cover object-center"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.fertilitycentercancun.com.mx/",
    "email": "info@fertilitycentercancun.com.mx",
    "phone": "+52 998 305 0373",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "Advanced Fertility Center Cancún es una clínica de fertilidad del estado mexicano de Quintana Roo que cuenta con laboratorio y quirófano propio, además de consultas, salas de exploración y habitaciones de recuperación. Este centro lleva a cabo diferentes servicios y cuenta con el apoyo de médicos internacionales.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-259",
    "name": "Biofertility Center",
    "address": {
      "id": "addr-mx-redlara-259",
      "address1": "Avenida Royal Country, 4650 - 301",
      "address2": null,
      "city": "Zapopan",
      "state": "JAL",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Biofertility Center",
    "images": [
      {
        "id": "mx-redlara-259-image-1",
        "url": "https://biofertilitycenter.com/wp-content/uploads/2021/06/Andrologia-Laboratorio-Biofertility-770x635.jpg",
        "name": "Andrologia Laboratorio Biofertility attachment-dsvy-img-770x635 size-dsvy-img-770x635 wp-post-image"
      },
      {
        "id": "mx-redlara-259-image-2",
        "url": "https://biofertilitycenter.com/wp-content/plugins/revslider/public/assets/assets/dummy.png",
        "name": "embarazada large rev-slidebg tp-rs-img rs-lazyload"
      },
      {
        "id": "mx-redlara-259-image-3",
        "url": "https://biofertilitycenter.com/wp-content/uploads/2022/02/bebe-1024x1024.jpg",
        "name": "bebe attachment-large size-large wp-image-3196"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.biofertilitycenter.com",
    "email": "admingdl@bfcbiofertilitycenter.com",
    "phone": "52-33) 36102799 36100913",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "BioFertility Center es un centro de reproducción asistida de México que cuenta con dos sedes, una en Guadalajara (Jalisco) y la otra en León (Guanajuato). Este centro cuenta con los medios y la tecnología necesaria para ofrecer a sus pacientes diferentes tratamientos de fertilidad.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-dir-cdelaf-mexico-city",
    "name": "CDELAF",
    "address": {
      "id": "addr-mx-dir-cdelaf-mexico-city",
      "address1": "",
      "address2": null,
      "city": "Mexico City",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "CDELAF",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "CDELAF es una clínica de fertilidad de la ciudad de México que ofrece diversos tratamientos de fertilidad y para ello dispone de laboratorio y quirófano en sus instalaciones.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-cedigine-fertilizacion-in-vitro-veracruz",
    "name": "Cedigine Fertilización In Vitro",
    "address": {
      "id": "addr-mx-dir-cedigine-fertilizacion-in-vitro-veracruz",
      "address1": "",
      "address2": null,
      "city": "Veracruz",
      "state": "VER",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Cedigine Fertilización In Vitro",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "La clínica de fertilidad Cedigine se encuentra en el estado mexicano de Veracruz, muy cerca del Aeropuerto Internacional de Veracruz. Esta clínica ofrece diversos tratamientos reproductivos, aunque desconocemos si cuenta con las instalaciones necesarias para ello.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-157",
    "name": "CEERH - Centro Especializado en Esterilidad y Reproducción Humana SC",
    "address": {
      "id": "addr-mx-redlara-157",
      "address1": "Hospital Angeles México - Agrarismo 208 1º piso Torre A, Colonia Escandon",
      "address2": null,
      "city": "Ciudad de México",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "CEERH - Centro Especializado en Esterilidad y Reproducción Humana SC",
    "images": [
      {
        "id": "mx-redlara-157-image-1",
        "url": "https://www.reproduccionceerh.com.mx/images_2/facebook.png",
        "name": "Facebook CEERH Síguenos en Facebook CEERH"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.reproduccionceerh.com.mx",
    "email": "ceeyrh@gmail.com",
    "phone": "52 (55) 5271-6218",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "Aquí es CEERH, Centro Especializado en Esterilidad y Reproducción Humana. Conjuntamos en un solo espacio físico a los especialistas necesarios y a la más alta tecnolgía para poder diagnosticar y, en su caso, tratar todo tipo de problemas relacionados con la Infertilidad y la Repoducción Humana. ¡Bienvenidos!",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-290",
    "name": "Centro CARE",
    "address": {
      "id": "addr-mx-redlara-290",
      "address1": "Gutenberg 175, Anzures, Miguel Hidalgo",
      "address2": null,
      "city": "Ciudad de México",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Centro CARE",
    "images": [
      {
        "id": "mx-redlara-290-image-1",
        "url": "https://img1.wsimg.com/isteam/ip/653e7994-d38c-467e-ba68-b1fb80e37b4e/Captura%20de%20pantalla%202026-01-14%20131158.png/:/rs=h:75,cg:true,m/qt=q:95",
        "name": "CARE x-el x-el-img c1-1 c1-2 c1-4 c1-z c1-v c1-w c1-2a c1-2b c1-2c c1-2d c1-2e c1-2f c1-3 c1-2g c1-2h c1-2i c1-2j c1-2k c1-2l c1-b c1-c c1-2m c1-2n c1-2o c1-2p c1-2q c1-2r c1-2s c1-2t c1-2u c1-2v c1-2w c1-2x c1-2y c1-2z c1-30 c1-d c1-31 c1-32 c1-33 c1-e c1-f c1-g"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.centrocare.mx/",
    "email": "elizabeth.gonzalez@grupomedicogem.com",
    "phone": "52-55-2623-1115",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-113",
    "name": "Centro de Diagnóstico Ginecológico",
    "address": {
      "id": "addr-mx-redlara-113",
      "address1": "Juan de Grijalva # 174 - Fracc. Reforma",
      "address2": null,
      "city": "Veracruz",
      "state": "VER",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Centro de Diagnóstico Ginecológico",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.cdgfertilidad.com.mx",
    "email": "yopo10@hotmail.com",
    "phone": "52 (229) 937 6797",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-58",
    "name": "Centro de Fertilidad IECH",
    "address": {
      "id": "addr-mx-redlara-58",
      "address1": "Av. Hidalgo 1842 Pte. 3er Piso. Colonia Obispado",
      "address2": null,
      "city": "Monterrey",
      "state": "NL",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Centro de Fertilidad IECH",
    "images": [
      {
        "id": "mx-redlara-58-image-1",
        "url": "https://iech.com.mx/iech/wp-content/uploads/2025/05/iech-banner-1.jpg",
        "name": "d-block w-100"
      },
      {
        "id": "mx-redlara-58-image-2",
        "url": "https://iech.com.mx/iech/wp-content/uploads/2022/10/Banner-prevenir-pagina-iech-1.jpg",
        "name": "d-block w-100"
      },
      {
        "id": "mx-redlara-58-image-3",
        "url": "https://iech.com.mx/iech/wp-content/uploads/2022/10/Banner-primer-paso-pagina-iech-2.jpg",
        "name": "d-block w-100"
      },
      {
        "id": "mx-redlara-58-image-4",
        "url": "https://iech.com.mx/iech/wp-content/uploads/2022/10/banner-home.jpg",
        "name": "d-block w-100"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://iech.com.mx/iech/",
    "email": "atencion.clientes@iech.com.mx",
    "phone": "+52 81 1642 2200",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-318",
    "name": "Centro de Innovacion Tecnologica y Medicina Reproductiva CITMER",
    "address": {
      "id": "addr-mx-redlara-318",
      "address1": "De la Clinica 2520 piso PB M- 4 y M-5, Sertoma",
      "address2": null,
      "city": "Monterrey",
      "state": "NL",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Centro de Innovacion Tecnologica y Medicina Reproductiva CITMER",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": "imaldonado@citmer.mx",
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-324",
    "name": "Centro de Innovacion Tecnologica y Medicina Reproductiva CITMER",
    "address": {
      "id": "addr-mx-redlara-324",
      "address1": "Torre JV Juárez, Av. Piso 13, La Paz, 72160 Puebla, Pue.",
      "address2": null,
      "city": "Puebla",
      "state": "PUE",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Centro de Innovacion Tecnologica y Medicina Reproductiva CITMER",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": "ijimenez@citmer.mx",
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-294",
    "name": "Centro de Innovación Tecnológica y Medicina Reproductiva CITMER",
    "address": {
      "id": "addr-mx-redlara-294",
      "address1": "Boulevard Miguel de Cervantes Saavedra No. 233, Piso 3, Colonia Granada, delegación Miguel Hidalgo, Ciudad de México",
      "address2": null,
      "city": "Ciudad de México",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Centro de Innovación Tecnológica y Medicina Reproductiva CITMER",
    "images": [
      {
        "id": "mx-redlara-294-image-1",
        "url": "https://citmer.com/wp-content/uploads/2025/02/clinica-de-fertilidad-cdmx-monterrey-puebla-recepcion.jpg",
        "name": "Centro de Innovación Tecnológica y Medicina Reproductiva CITMER"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://citmer.mx/",
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "CITMER es una clínica de fertilidad privada que cuenta con tres sedes repartidas por México: Monterrey, Puebla y Ciudad de México. Estas tres clínicas disponen de laboratorio propio de FIV según la información de su página Web.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-56",
    "name": "Centro de Medicina Reproductiva FILIUS",
    "address": {
      "id": "addr-mx-redlara-56",
      "address1": "Av. Palmira, 600, Fracc. Villas del Pedregal",
      "address2": null,
      "city": "San Luis Potosí",
      "state": "SLP",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Centro de Medicina Reproductiva FILIUS",
    "images": [
      {
        "id": "mx-redlara-56-image-1",
        "url": "https://www.filius.mx/Pictures/HospitalLomas.JPG",
        "name": "Centro de Medicina Reproductiva FILIUS"
      },
      {
        "id": "mx-redlara-56-image-2",
        "url": "https://www.filius.mx/Pictures/pareja.jpg",
        "name": "Centro de Medicina Reproductiva FILIUS"
      },
      {
        "id": "mx-redlara-56-image-3",
        "url": "https://www.filius.mx/Pictures/Consultorio.jpg",
        "name": "Centro de Medicina Reproductiva FILIUS"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.filius.mx/",
    "email": "administracion@filius.mx",
    "phone": "+52 (444) 123 1222",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "El Centro de Medicina Reproductiva FILIUS es una clínica privada de fertilidad que se encuentra dentro del Hospital Lomas de San Luis, ubicado en el estado mexicano de San Luis Potosí. Este centro cuenta con laboratorio de andrología y de FIV, además de quirófano.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-98",
    "name": "Centro de Reproducción Asistida de Occidente",
    "address": {
      "id": "addr-mx-redlara-98",
      "address1": "Quebec #631-104, Col. Providencia",
      "address2": null,
      "city": "Guadalajara",
      "state": "JAL",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Centro de Reproducción Asistida de Occidente",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://fertinvitro.care/",
    "email": "mexcrao@hotmail.com",
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-229",
    "name": "Centro de Reproducción Asistida de Saltillo",
    "address": {
      "id": "addr-mx-redlara-229",
      "address1": "Av. Adrian Muguerza, 1115 int. 105 - Colonia Brisas",
      "address2": null,
      "city": "Saltillo",
      "state": "COAH",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Centro de Reproducción Asistida de Saltillo",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": "alvaro.ramosal@gmail.com",
    "phone": "52-844) 416-4696",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "CREAS Saltillo es el Centro de Reproducción Asistida del Saltillo, en México, donde ofrecen a sus pacientes diferentes tratamientos de fertilidad.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-centro-mexicano-de-fertilidad-dr-alberto-kably-huixquilucan",
    "name": "Centro Mexicano de Fertilidad Dr. Alberto Kably",
    "address": {
      "id": "addr-mx-dir-centro-mexicano-de-fertilidad-dr-alberto-kably-huixquilucan",
      "address1": "",
      "address2": null,
      "city": "Huixquilucan",
      "state": "MEX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Centro Mexicano de Fertilidad Dr. Alberto Kably",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "El Centro Mexicano de Fertilidad Dr. Alberto Kably está localizado en el Hospital Ángeles Loma de México. Aquí trabajan dos ginecólogos y una embrióloga para llevar a cabo tanto tratamientos de inseminación artificial (IA) como de fecundación in vitro (FIV) y transferencias embrionarias.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-centro-origen-merida",
    "name": "Centro ORIGEN",
    "address": {
      "id": "addr-mx-dir-centro-origen-merida",
      "address1": "",
      "address2": null,
      "city": "Mérida",
      "state": "YUC",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Centro ORIGEN",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "El Centro ORIGEN mx se encuentra integrado en el Cenit Medical Center de Mérdida, Yucatán. Este centro de fertilidad ofrece diferentes tratamientos reproductivos, así como servicios de cirugía reproductiva mediante histeroscopia y laparoscopia.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-158",
    "name": "Centro Universitario de Medicina Reproductiva - CEUMER",
    "address": {
      "id": "addr-mx-redlara-158",
      "address1": "Centro Universitario de Medicina Reproductiva, Hospital Universitario \"Dr. José Eleuterio González\", Edificio Jesús Gracia Garza, 4to. Piso",
      "address2": null,
      "city": "Monterrey",
      "state": "NL",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Centro Universitario de Medicina Reproductiva - CEUMER",
    "images": [
      {
        "id": "mx-redlara-158-image-1",
        "url": "https://ceumer.com/wp-content/uploads/2022/08/laboratorio.jpg",
        "name": "et-waypoint et_pb_animation_off et_pb_animation_off_tablet et_pb_animation_off_phone wp-image-1422"
      },
      {
        "id": "mx-redlara-158-image-2",
        "url": "https://ceumer.com/wp-content/uploads/2022/06/doctor.png",
        "name": "et-waypoint et_pb_animation_top et_pb_animation_top_tablet et_pb_animation_top_phone wp-image-256"
      },
      {
        "id": "mx-redlara-158-image-3",
        "url": "https://ceumer.com/wp-content/uploads/2022/06/biologia-reproduccion.png",
        "name": "et-waypoint et_pb_animation_off et_pb_animation_off_tablet et_pb_animation_off_phone wp-image-232"
      },
      {
        "id": "mx-redlara-158-image-4",
        "url": "https://ceumer.com/wp-content/uploads/2022/06/menopausia.png",
        "name": "et-waypoint et_pb_animation_off et_pb_animation_off_tablet et_pb_animation_off_phone wp-image-233"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://ceumer.com/",
    "email": "citas@ceumer.com",
    "phone": "52 (81) 8348-3054",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "El Centro Universitario de Medicina Reproductiva (CeuMeR) es una clínica de fertilidad que forma parte del Campus Ciencias de la Salud UANL de Monterrey. Este centro ofrece diversos tratamientos de fertilidad, para la menopausia y para la osteoporosis. Además, CeuMeR lleva a cabo actividades de investigación.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-57",
    "name": "CEPAM - Centro Especializado para la Atención de la Mujer",
    "address": {
      "id": "addr-mx-redlara-57",
      "address1": "Vialidad de la Barranca s/n- consultorio 240, Col. Valle de las Palmas",
      "address2": null,
      "city": "Huixquilucan",
      "state": "MEX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "CEPAM - Centro Especializado para la Atención de la Mujer",
    "images": [
      {
        "id": "mx-redlara-57-image-1",
        "url": "https://www.kablyfertilidad.com/images/k_index/banner3.jpg",
        "name": "rev-slidebg"
      },
      {
        "id": "mx-redlara-57-image-2",
        "url": "https://www.kablyfertilidad.com/images/k_index/banner1.jpg",
        "name": "rev-slidebg"
      },
      {
        "id": "mx-redlara-57-image-3",
        "url": "https://www.kablyfertilidad.com/images/k_index/banner2.jpg",
        "name": "rev-slidebg"
      },
      {
        "id": "mx-redlara-57-image-4",
        "url": "https://www.kablyfertilidad.com/images/k_index/img1.jpg",
        "name": "Fachada hospital"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.kablyfertilidad.com/",
    "email": "cepam1999@gmail.com",
    "phone": "+52 55 5246 94 18",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "El Centro Mexicano de Fertilidad Doctor Alberto Kably es una institución de gran renombre y experencia en el área de fertilidad y ginecobsgetricia.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-303",
    "name": "CERH - Centro para el Estudio de la Reproducción Humana",
    "address": {
      "id": "addr-mx-redlara-303",
      "address1": "Calle Acacias, 1876, Fracc. Gamez",
      "address2": null,
      "city": "Irapuato",
      "state": "GTO",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "CERH - Centro para el Estudio de la Reproducción Humana",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": "clinicacerh@outlook.com",
    "phone": "+52-462-6350035",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-cerh-clinica-para-el-estudio-de-la-reproduccion-humana-irapuato",
    "name": "CERH | Clínica para el Estudio de la Reproducción Humana - Irapuato",
    "address": {
      "id": "addr-mx-dir-cerh-clinica-para-el-estudio-de-la-reproduccion-humana-irapuato",
      "address1": "",
      "address2": null,
      "city": "Irapuato",
      "state": "GTO",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "CERH | Clínica para el Estudio de la Reproducción Humana - Irapuato",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "La Clínica para el Estudio de la Reproducción Humana (CERH) es un centro de fertilidad que cuenta con dos sedes, una en Irapauto y otra en Torreón, Este centro ofrece diversos tratamientos reproductivos, además de otros servicios. CERH también dispone de opciones de financiación.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-cerh-clinica-para-el-estudio-de-la-reproduccion-humana-torreon",
    "name": "CERH | Clínica para el Estudio de la Reproducción Humana - Torreón",
    "address": {
      "id": "addr-mx-dir-cerh-clinica-para-el-estudio-de-la-reproduccion-humana-torreon",
      "address1": "",
      "address2": null,
      "city": "Torreón",
      "state": "COAH",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "CERH | Clínica para el Estudio de la Reproducción Humana - Torreón",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "La Clínica para el Estudio de la Reproducción Humana (CERH) es un centro de fertilidad que cuenta con dos sedes, una en Irapauto y otra en Torreón, Este centro ofrece diversos tratamientos reproductivos, además de otros servicios. CERH también dispone de opciones de financiación.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-273",
    "name": "Clinica de Infertilidad y Reproducción Asistida de Toluca",
    "address": {
      "id": "addr-mx-redlara-273",
      "address1": "Calle Pedro Ascencio 427, consultorio 418, Colonia Barrio Santa Cruz. Metepec Estado de México. Torre de Servicios Especializados del Centro Medico Toluca",
      "address2": null,
      "city": "Metepec",
      "state": "MEX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Clinica de Infertilidad y Reproducción Asistida de Toluca",
    "images": [
      {
        "id": "mx-redlara-273-image-1",
        "url": "https://clinicainfertilidadtoluca.com/wp-content/uploads/2024/03/Diseno-sin-titulo-8.png",
        "name": "Clinica de Infertilidad y Reproducción Asistida de Toluca"
      },
      {
        "id": "mx-redlara-273-image-2",
        "url": "https://clinicainfertilidadtoluca.com/wp-content/uploads/2024/03/3-1024x687.jpg",
        "name": "attachment-large size-large wp-image-132"
      },
      {
        "id": "mx-redlara-273-image-3",
        "url": "https://clinicainfertilidadtoluca.com/wp-content/uploads/2024/03/1.png",
        "name": "DR JULIAN attachment-large size-large wp-image-144"
      },
      {
        "id": "mx-redlara-273-image-4",
        "url": "https://clinicainfertilidadtoluca.com/wp-content/uploads/2023/01/img35-300x300.png",
        "name": "attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://clinicainfertilidadtoluca.com/",
    "email": "clinicainfertilidadtoluca@gmail.com",
    "phone": "52-722) 210-5660",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "La Clínica de Infertilidad y Reproducción Asistida de Toluca In FIV es un centro de fertilidad privado del estado de México que cuenta con laboratorio propio. Además, este centro dispone de banco de semen y lleva a cabo histeroscopias.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-283",
    "name": "Clínica Nascere",
    "address": {
      "id": "addr-mx-redlara-283",
      "address1": "Paseo de los Tamarindos, 90 Torre 1, piso 2. Col. Bosque de las Lomas. Cuajimalpa de Morelos",
      "address2": null,
      "city": "Ciudad de México",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Clínica Nascere",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.nascere.com.mx",
    "email": "contacto@nascere.org.mx",
    "phone": "52-55) 9135-0120",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-291",
    "name": "CONCIBO",
    "address": {
      "id": "addr-mx-redlara-291",
      "address1": "Calle Jose Maria Velazco #2524, Colonia Zona Urbana Rio Tijuana",
      "address2": null,
      "city": "Tijuana",
      "state": "BC",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "CONCIBO",
    "images": [
      {
        "id": "mx-redlara-291-image-1",
        "url": "https://conciboclinic.com/wp-content/uploads/2021/02/ROPA-header-1.0.jpg",
        "name": "CONCIBO"
      },
      {
        "id": "mx-redlara-291-image-2",
        "url": "https://conciboclinic.com/wp-content/uploads/2024/06/IMG_6615-scaled.jpg",
        "name": "CONCIBO"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.conciboclinic.com/",
    "email": "info@conciboclinic.com",
    "phone": "+52 664 6340674",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "CONCIBE es una clínica de reproducción asistida ubicada en la Ciudad de México. Este centro de fertilidad dispone de un amplio abanico de tratamientos de fertilidad y también cuenta con banco de semen.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "08:00",
        "close": "19:00"
      },
      "tue": {
        "open": "08:00",
        "close": "19:00"
      },
      "wed": {
        "open": "08:00",
        "close": "19:00"
      },
      "thu": {
        "open": "08:00",
        "close": "19:00"
      },
      "fri": {
        "open": "08:00",
        "close": "19:00"
      },
      "sat": null,
      "sun": null
    }
  },
  {
    "id": "mx-dir-concibo-reproductive-clinic-tijuana",
    "name": "Concibo Reproductive Clinic",
    "address": {
      "id": "addr-mx-dir-concibo-reproductive-clinic-tijuana",
      "address1": "",
      "address2": null,
      "city": "Tijuana",
      "state": "BC",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Concibo Reproductive Clinic",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Concibo Reproductive Clinic es un centro de fertilidad que ofrece a sus pacientes diversos tratamientos de fertilidad y también la opción de cirugía ambulatoria. Además, entre las instalaciones de Concibo Reproductive Clinic se encuentra un laboratorio y un quirófano.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-54",
    "name": "Creasis San Pedro",
    "address": {
      "id": "addr-mx-redlara-54",
      "address1": "Av. Real San Agustin, 222 local TA-106, Real San Agustin",
      "address2": null,
      "city": "San Pedro Garza Garcia",
      "state": "NL",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Creasis San Pedro",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://creasissanpedro.com",
    "email": "contacto@creasissanpedro.com",
    "phone": "52-818) 348-467",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "CREASIS San Pedro es una clínica de fertilidad privada ubicada en el estado mexicano de Nuevo León, concretamente en Monterrey. Este centro cuenta con laboratorio de andrología y embriología para llevar a cabo diversos tratamientos de fertilidad y cirugía reproductiva.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-322",
    "name": "Dr. Cigüeña",
    "address": {
      "id": "addr-mx-redlara-322",
      "address1": "Reforma 1777 Colonia Nueva",
      "address2": null,
      "city": "Mexicali",
      "state": "BC",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Dr. Cigüeña",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": "lsoto@doctorciguena.com",
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-340",
    "name": "Eligen Fertility Center",
    "address": {
      "id": "addr-mx-redlara-340",
      "address1": "Callao, 693 - Lindavista Norte, Alcadia Gustavo A. Madero",
      "address2": null,
      "city": "Ciudad de México",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Eligen Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": "fiv.izquierdo@eligen.com.mx",
    "phone": "+52 55 2270 2040",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-361",
    "name": "Endofertyl",
    "address": {
      "id": "addr-mx-redlara-361",
      "address1": "Monte Everest # 1215. Fracc. Valle del Campestre.",
      "address2": null,
      "city": "Aguascalientes",
      "state": "AGS",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Endofertyl",
    "images": [
      {
        "id": "mx-redlara-361-image-1",
        "url": "https://endofertyl.com/#",
        "name": "insta-image"
      },
      {
        "id": "mx-redlara-361-image-2",
        "url": "https://endofertyl.com/images/static/01.jpg",
        "name": "border-radius-10px"
      },
      {
        "id": "mx-redlara-361-image-3",
        "url": "https://endofertyl.com/images/static/JoseDanielContrerasGarza.jpg",
        "name": "Endofertyl"
      },
      {
        "id": "mx-redlara-361-image-4",
        "url": "https://endofertyl.com/images/static/DiegoAlonsoGonzalezAzuara.jpg",
        "name": "Endofertyl"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://endofertyl.com/",
    "email": "atencionpacientes@endofertyl.mx",
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "Endofertyl es una clínica de reproducción asistida ubicada en Aguascalientes, un estado de México. Este centro de fertilidad un amplio abanico de tratamientos reproductivos, pero también atención materno-fetal, cirugía reproductiva, tratamiento de la endometriosis, etc.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-dir-fertifem-cuautla",
    "name": "FertiFem",
    "address": {
      "id": "addr-mx-dir-fertifem-cuautla",
      "address1": "",
      "address2": null,
      "city": "Cuautla",
      "state": "MOR",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "FertiFem",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "FertiFem es una unidad integral de ginecología y fertilidad que se encuentra dentro del Centro Médico del Ángel, aunque también tiene otra sede en el corporativo pirámide de Vista Hermosa.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-fertilcenter-aguascalientes",
    "name": "Fertilcenter",
    "address": {
      "id": "addr-mx-dir-fertilcenter-aguascalientes",
      "address1": "",
      "address2": null,
      "city": "Aguascalientes",
      "state": "AGS",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Fertilcenter",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Fertilcenter es un centro de reproducción asistida privado localizado en Aguascalientes (México). Esta clínica de fertilidad dispone de laboratorio, cuya actividad se puede observar desde la sala de espera, y también de quirófano propio.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-342",
    "name": "Fertilidad Integral",
    "address": {
      "id": "addr-mx-redlara-342",
      "address1": "Av. Ejército Nacional, 769 - Polanco",
      "address2": null,
      "city": "Ciudad de México",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Fertilidad Integral",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": "jose_alfonso_gutierrez@yahoo.com",
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-319",
    "name": "Fertilitá Medicina Reproductiva",
    "address": {
      "id": "addr-mx-redlara-319",
      "address1": "Belsario Dominguez 2725 Col. Obispado SUITE 201",
      "address2": null,
      "city": "Monterrey",
      "state": "NL",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Fertilitá Medicina Reproductiva",
    "images": [
      {
        "id": "mx-redlara-319-image-1",
        "url": "https://fertilita.com.mx/wp-content/uploads/2024/03/Familia-899x1024.webp",
        "name": "Fertilitá Medicina Reproductiva"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://fertilita.com.mx/",
    "email": "samuel.lopez@fertilita.com.mx",
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "Fertilità Medicina Reproductiva es una clínica de fertilidad privada que se encuentra en la ciudad de Monterrey, en el estado mexicano de Nuevo León. Este centro ofrece diversas técnicas de reproducción asistida, cirugía reproductiva y farmacia a sus pacientes.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true,
    "schedule": {
      "mon": {
        "open": "07:30",
        "close": "20:00"
      },
      "tue": {
        "open": "07:30",
        "close": "20:00"
      },
      "wed": {
        "open": "07:30",
        "close": "20:00"
      },
      "thu": {
        "open": "07:30",
        "close": "20:00"
      },
      "fri": {
        "open": "07:30",
        "close": "20:00"
      },
      "sat": {
        "open": "07:30",
        "close": "14:00"
      },
      "sun": null
    }
  },
  {
    "id": "mx-dir-fertilite-queretaro-santiago-de-queretaro",
    "name": "Fertilite Querétaro",
    "address": {
      "id": "addr-mx-dir-fertilite-queretaro-santiago-de-queretaro",
      "address1": "",
      "address2": null,
      "city": "Santiago de Querétaro",
      "state": "QRO",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Fertilite Querétaro",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Fertilite Querétaro es un centro de fertilidad que se encuentra dentro del Hospital de Querétaro en México. Se trata de una clínica que ofrece diversos tratamientos de fertilidad, selección del sexo y cuenta con banco de semen y de óvulos.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-fertility-clinic-americas-cancun",
    "name": "Fertility Clinic Americas",
    "address": {
      "id": "addr-mx-dir-fertility-clinic-americas-cancun",
      "address1": "",
      "address2": null,
      "city": "Cancún",
      "state": "QROO",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Fertility Clinic Americas",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Fertility Clinic Americas es un centro de reproducción asistida de entidad privada que se encuentra en la ciudad de Cancún, México. Este centro de fertilidad ofrece diversos tratamientos de fertilidad, pero también cuenta con otros servicios como, por ejemplo, medicina fetal o ginecología general.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-fertility-day-mexico-city",
    "name": "Fertility Day",
    "address": {
      "id": "addr-mx-dir-fertility-day-mexico-city",
      "address1": "",
      "address2": null,
      "city": "Mexico City",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Fertility Day",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "La clínica Fertility Day está ubicada en el barrio de Cuauhtémoc de la Ciudad de México. Esta clínica ofrece tratamientos de fertilidad, ginecología, seguimiento del embarazo y cirugía. Por ello, la clínica cuenta con laboratorio y quirófano propio, así como habitaciones para la recuperación tras una intervención.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-fertilymed-cancun",
    "name": "FertilyMed",
    "address": {
      "id": "addr-mx-dir-fertilymed-cancun",
      "address1": "",
      "address2": null,
      "city": "Cancún",
      "state": "QROO",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "FertilyMed",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "FertilyMed es una clínica de reproducción asistida ubicada en una de las zonas más lujosas de Cancún. Este centro cuenta con laboratorio propio y quirófano. Su directora médica es la Dra. Eunice Zavala; mientras que el laboratorio está dirigido por la embrióloga Olena Glasenko.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-fiv-oaxaca-oaxaca",
    "name": "FIV Oaxaca",
    "address": {
      "id": "addr-mx-dir-fiv-oaxaca-oaxaca",
      "address1": "",
      "address2": null,
      "city": "Oaxaca",
      "state": "OAX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "FIV Oaxaca",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "FIV Oaxaca, como su nombre indica, es un centro de fertilidad ubicado en el estado mexicano de Oaxaca, en la ciudad Oaxaca de Juárez. Este centro de fertilidad cuenta con banco de óvulos propios, pero también de semen.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-gestare-star-medica-chihuahua",
    "name": "Gestare Star Médica",
    "address": {
      "id": "addr-mx-dir-gestare-star-medica-chihuahua",
      "address1": "",
      "address2": null,
      "city": "Chihuahua",
      "state": "CHIH",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Gestare Star Médica",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Gestare es una unidad de reproducción asistida que se encuentra dentro del Hospital Star Médica de Chihuahua (México) que lleva abierta 25 años. Esta unidad ofrece diversos tratamientos de fertilidad y para ello cuenta con un equipo multidisciplinar de profesionales.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-gynefiv-apizaco",
    "name": "GyneFIV",
    "address": {
      "id": "addr-mx-dir-gynefiv-apizaco",
      "address1": "",
      "address2": null,
      "city": "Apizaco",
      "state": "TLAX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "GyneFIV",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "GyneFIV es un centro de reproducción asistida que cuenta con tres sedes repartidas por diferentes estados mexicanos. Este centro, además de realizar tratamientos de fertilidad, también ofrece servicios de ginecología, obstetricia y cirugía.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-gynfertil-aguascalientes",
    "name": "GynFertil",
    "address": {
      "id": "addr-mx-dir-gynfertil-aguascalientes",
      "address1": "",
      "address2": null,
      "city": "Aguascalientes",
      "state": "AGS",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "GynFertil",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "GynFertil es un centro de fertilidad ubicado en el Hospital MAC de Aguascalientes Norte. Este centro de fertilidad dispone de la opción de consultas por videollamada para facilitar la atención de los pacientes que residan fuera de la ciudad y/o del país.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-204",
    "name": "GYRA de Puebla",
    "address": {
      "id": "addr-mx-redlara-204",
      "address1": "21 Poniente, 3713 Col. Belisario Dominguez",
      "address2": null,
      "city": "Puebla",
      "state": "PUE",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "GYRA de Puebla",
    "images": [
      {
        "id": "mx-redlara-204-image-1",
        "url": "https://static.wixstatic.com/media/e050a2_bcc047209ade4031bf214f3d96cb4bdf~mv2.jpg/v1/fill/w_192,h_288,al_c,q_80,usm_0.66_1.00_0.01,blur_2,enc_avif,quality_auto/e050a2_bcc047209ade4031bf214f3d96cb4bdf~mv2.jpg",
        "name": "GYRA de Puebla"
      },
      {
        "id": "mx-redlara-204-image-2",
        "url": "https://static.wixstatic.com/media/e050a2_1968248868be4a3894f9e62e0f317740~mv2.png/v1/fill/w_142,h_35,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/e050a2_1968248868be4a3894f9e62e0f317740~mv2.png",
        "name": "W1Wg1l sFiSiq"
      },
      {
        "id": "mx-redlara-204-image-3",
        "url": "https://static.wixstatic.com/media/e050a2_1aa757b53f9045d9b77a7d904a58f779~mv2.jpg/v1/crop/x_369,y_0,w_1557,h_1417/fill/w_579,h_527,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Captura%20de%20pantalla%202025-12-03%20a%20la(s)%201.jpg",
        "name": "Captura de pantalla 2025-12-03 a la(s) 1 gRkIq0 sFiSiq"
      },
      {
        "id": "mx-redlara-204-image-4",
        "url": "https://static.wixstatic.com/media/e050a2_b1ee51b47fac43f4adf5bf466cfece83~mv2.png/v1/fill/w_147,h_36,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/e050a2_b1ee51b47fac43f4adf5bf466cfece83~mv2.png",
        "name": "gRkIq0 sFiSiq"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.gyra.com.mx",
    "email": "marinomiguelg@hotmail.com",
    "phone": "52-222) 296-6382",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-dir-hestia-fertility-mexico-city",
    "name": "Hestia Fertility",
    "address": {
      "id": "addr-mx-dir-hestia-fertility-mexico-city",
      "address1": "",
      "address2": null,
      "city": "Mexico City",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Hestia Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "La clínica Hestia Fertility es un centro de fertilidad privado con laboratorio propio dirigido por un equipo de profesionales, todas ellas mujeres. Este centro, además de realizar tratamientos reproductivos, también ofrece asesoramiento genético, nutricional, psicológico, etc.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-203",
    "name": "Hisparep",
    "address": {
      "id": "addr-mx-redlara-203",
      "address1": "Ejercito nacional 613-101 11520 col granada deleg miguel hidalgo cdmx",
      "address2": null,
      "city": "Ciudad de México",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Hisparep",
    "images": [
      {
        "id": "mx-redlara-203-image-1",
        "url": "https://www.hisparep.com.mx/wp-content/uploads/2025/02/Header-servicios.png",
        "name": "Header servicios Ipad wp-image-6496"
      },
      {
        "id": "mx-redlara-203-image-2",
        "url": "https://www.hisparep.com.mx/wp-content/uploads/2025/02/Bullet.png",
        "name": "Hisparep"
      },
      {
        "id": "mx-redlara-203-image-3",
        "url": "https://www.hisparep.com.mx/wp-content/uploads/2025/02/Quienes-somos.png",
        "name": "Quienes somos wp-image-6475"
      },
      {
        "id": "mx-redlara-203-image-4",
        "url": "https://www.hisparep.com.mx/wp-content/uploads/2025/02/Estadistica-infertilidad.png",
        "name": "et-waypoint et_pb_animation_top et_pb_animation_top_tablet et_pb_animation_top_phone wp-image-6430"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.hisparep.com.mx/",
    "email": "admin@hisparep.com",
    "phone": "52-55) 5250-6462",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "HISPAREP es una clínica de reproducción asistida localizada en las instalaciones del Hospital Español, en Ciudad de México, México. Este centro cuenta con un equipo multidisciplinar y ofrecen a sus pacientes diversos servicios.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-236",
    "name": "Hospital Angeles del Pedregal SA de CV",
    "address": {
      "id": "addr-mx-redlara-236",
      "address1": "Camino a Santa Teresa, 1055, Col. Heroes de Padierna",
      "address2": null,
      "city": "Ciudad de México",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Hospital Angeles del Pedregal SA de CV",
    "images": [
      {
        "id": "mx-redlara-236-image-1",
        "url": "https://hospitalangeles.com/assets/img/imgservicios/laboratorio-clinico.webp",
        "name": "Médico de Hospital Angeles con bata blanca, cubrebocas y guantes, acomodando muestras de laboratorio para ser analizadas"
      },
      {
        "id": "mx-redlara-236-image-2",
        "url": "https://hospitalangeles.com/assets/img/imgservicios/clinica-de-diagnostico-y-check-up.webp",
        "name": "Paciente corriendo en una caminadora para un estudio de check up, siendo monitoreado por el médico"
      },
      {
        "id": "mx-redlara-236-image-3",
        "url": "https://hospitalangeles.com/assets/img/imgservicios/clinica-de-medicina-fisica-y-rehabilitacion-(advanced-therapy).webp",
        "name": "Paciente recostada en un equipo de magnetoterapia de color azul con blanco. A su lado se encuentra una fisioterapeuta"
      },
      {
        "id": "mx-redlara-236-image-4",
        "url": "https://hospitalangeles.com/assets/img/imgservicios/laboratorio-de-anatomia-patologica.webp",
        "name": "Médico de Hospital Angeles analizando una muestra de laboratorio con un microscopio"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.hospitalangelespedregal.com.mx",
    "email": "leticia.compean@saludangeles.com",
    "phone": "52-55) 5449-5500",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "Distintivo H, HUCI y acreditación del Consejo de Salubridad respaldan la calidad, higiene y seguridad del Hospital Angeles Pedregal. Conócelas.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-166",
    "name": "IECH de B.C.",
    "address": {
      "id": "addr-mx-redlara-166",
      "address1": "Leona Vicario # 1450 suite 6, Zona Río",
      "address2": null,
      "city": "Tijuana",
      "state": "BC",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "IECH de B.C.",
    "images": [
      {
        "id": "mx-redlara-166-image-1",
        "url": "https://iech.com.mx/iech/wp-content/uploads/2025/05/iech-banner-1.jpg",
        "name": "d-block w-100"
      },
      {
        "id": "mx-redlara-166-image-2",
        "url": "https://iech.com.mx/iech/wp-content/uploads/2022/10/Banner-prevenir-pagina-iech-1.jpg",
        "name": "d-block w-100"
      },
      {
        "id": "mx-redlara-166-image-3",
        "url": "https://iech.com.mx/iech/wp-content/uploads/2022/10/Banner-primer-paso-pagina-iech-2.jpg",
        "name": "d-block w-100"
      },
      {
        "id": "mx-redlara-166-image-4",
        "url": "https://iech.com.mx/iech/wp-content/uploads/2022/10/banner-home.jpg",
        "name": "d-block w-100"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.iech.com.mx",
    "email": "droscarleon15@yahoo.com",
    "phone": "52-664) 684-0888",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-262",
    "name": "Ingenes Guadalajara",
    "address": {
      "id": "addr-mx-redlara-262",
      "address1": "Av. Mar del Sur 2014 local 102. Col. Country Club",
      "address2": null,
      "city": "Guadalajara",
      "state": "JAL",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Ingenes Guadalajara",
    "images": [
      {
        "id": "mx-redlara-262-image-1",
        "url": "https://www.ingenes.com/images/equipo-clinico.jpg",
        "name": "Equipo médico de Ingenes durante un procedimiento"
      },
      {
        "id": "mx-redlara-262-image-2",
        "url": "https://www.ingenes.com/images/award-eshre.webp",
        "name": "European Society of Human Reproduction and Embryology"
      },
      {
        "id": "mx-redlara-262-image-3",
        "url": "https://ingenes.com/images/og/og-home-es.jpg",
        "name": "Ingenes Guadalajara"
      },
      {
        "id": "mx-redlara-262-image-4",
        "url": "https://www.ingenes.com/images/20-anos.webp",
        "name": "20 años de Ingenes badge-20"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.ingenes.com",
    "email": "atencionpacientesgdl@ingenes.com",
    "phone": "52-33) 4770-1400",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "Tasa de éxito #1 en Latinoamérica y 10% más alta que clínicas de EE.UU. 75,000 bebés logrados, 22 sucursales en México y EE.UU. Tu camino empieza acá.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-195",
    "name": "INGENES México",
    "address": {
      "id": "addr-mx-redlara-195",
      "address1": "Carretera Mexico - Toluca #5420, Piso 6, Oficina 602. Colonia El Yaqui. Delegación Cuajimalpa de Morelos",
      "address2": null,
      "city": "Ciudad de México",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "INGENES México",
    "images": [
      {
        "id": "mx-redlara-195-image-1",
        "url": "https://www.ingenes.com/images/equipo-clinico.jpg",
        "name": "Equipo médico de Ingenes durante un procedimiento"
      },
      {
        "id": "mx-redlara-195-image-2",
        "url": "https://www.ingenes.com/images/award-eshre.webp",
        "name": "European Society of Human Reproduction and Embryology"
      },
      {
        "id": "mx-redlara-195-image-3",
        "url": "https://ingenes.com/images/og/og-home-es.jpg",
        "name": "INGENES México"
      },
      {
        "id": "mx-redlara-195-image-4",
        "url": "https://www.ingenes.com/images/20-anos.webp",
        "name": "20 años de Ingenes badge-20"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.ingenes.com",
    "email": "atencionalpaciente@ingenes.com",
    "phone": "52-55) 27899826",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "Tasa de éxito #1 en Latinoamérica y 10% más alta que clínicas de EE.UU. 75,000 bebés logrados, 22 sucursales en México y EE.UU. Tu camino empieza acá.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-dir-iniciar-ciudad-juarez",
    "name": "Iniciar",
    "address": {
      "id": "addr-mx-dir-iniciar-ciudad-juarez",
      "address1": "",
      "address2": null,
      "city": "Ciudad Juárez",
      "state": "CHIH",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Iniciar",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Iniciar Medicina Reproductiva es un centro de reproducción asistida de México, ubicado en el Hospital Ángeles de Ciudad Juárez. Este centro cuenta con un equipo multidisciplinar que ofrece a sus pacientes diversos servicios.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-327",
    "name": "INICIAR - Instituto de Investigación Científica en Infertilidad- Andrología y Reproducción",
    "address": {
      "id": "addr-mx-redlara-327",
      "address1": "Av. Campos Eliseos, 9371, Hosp. Angeles 7º piso, cons. 755",
      "address2": null,
      "city": "Ciudad Juarez",
      "state": "CHIH",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "INICIAR - Instituto de Investigación Científica en Infertilidad- Andrología y Reproducción",
    "images": [
      {
        "id": "mx-redlara-327-image-1",
        "url": "https://iniciar.mx/images/doctor-rocio.jpg",
        "name": "img-responsive"
      },
      {
        "id": "mx-redlara-327-image-2",
        "url": "https://iniciar.mx/images/doctor-griselda.jpg",
        "name": "img-responsive"
      },
      {
        "id": "mx-redlara-327-image-3",
        "url": "https://iniciar.mx/images/aldo.png",
        "name": "media-object"
      },
      {
        "id": "mx-redlara-327-image-4",
        "url": "https://iniciar.mx/images/laura.png",
        "name": "media-object"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://iniciar.mx",
    "email": "recepcion.iniciar@gmail.com",
    "phone": "+52 656-2271983",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "Iniciar es una clínica de tratamiento de infertilidad y medicina reproductiva. Ofrece alternativas de reproducción asistida, fertilización invitro, inseminación artificial, así como otros tratamientos para esterilidad.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-228",
    "name": "INMATER - Instituto Mexicano de Tecnologia Reproductiva",
    "address": {
      "id": "addr-mx-redlara-228",
      "address1": "Sierra Mojada 340",
      "address2": null,
      "city": "Ciudad de México",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "INMATER - Instituto Mexicano de Tecnologia Reproductiva",
    "images": [
      {
        "id": "mx-redlara-228-image-1",
        "url": "https://inmater.com/wp-content/uploads/InmaterFIV-1.webp",
        "name": "INMATER - Instituto Mexicano de Tecnologia Reproductiva"
      },
      {
        "id": "mx-redlara-228-image-2",
        "url": "https://inmater.com/wp-content/uploads/qoute-img-1.png",
        "name": "comilas"
      },
      {
        "id": "mx-redlara-228-image-3",
        "url": "https://inmater.com/wp-content/uploads/service-img1inma.png",
        "name": "Consulta Diagnostica de Infertilidad Consulta Diagnostica de Infertilidad"
      },
      {
        "id": "mx-redlara-228-image-4",
        "url": "https://inmater.com/wp-content/uploads/service-img3.png",
        "name": "Inseminación Artificial Inseminación Artificial"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.inmater.com",
    "email": "info@inmater.com",
    "phone": "52-55) 5540-2218",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "Instituto Mexicano de tecnología reproductiva o INMATER es un centro de fertilidad ubicado en Ciudad de México que cuenta con laboratorio y quirófano propio según un vídeo publicado en su Web. Este centro realiza ciclos de inseminación artificial, fecundación in vitro, método ROPA y preservación de la fertilidad.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-111",
    "name": "Instituto de Ciencias en Reprodución Humana -VIDA-Matamoros",
    "address": {
      "id": "addr-mx-redlara-111",
      "address1": "Calle Alhelies # 51 entre 1a. Y 2a. Colonia Jardín",
      "address2": null,
      "city": "Matamoros",
      "state": "TAMPS",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Instituto de Ciencias en Reprodución Humana -VIDA-Matamoros",
    "images": [
      {
        "id": "mx-redlara-111-image-1",
        "url": "https://www.institutovida.com/images/slider-2.jpg",
        "name": "... d-block w-100"
      },
      {
        "id": "mx-redlara-111-image-2",
        "url": "https://www.institutovida.com/images/slider-3.jpg",
        "name": "... d-block w-100"
      },
      {
        "id": "mx-redlara-111-image-3",
        "url": "https://www.institutovida.com/images/slider.png",
        "name": "... d-block w-100"
      },
      {
        "id": "mx-redlara-111-image-4",
        "url": "https://www.institutovida.com/images/AN_Foto-14%201.jpg",
        "name": "Image sppb-img-responsive"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.institutovida.com",
    "email": "maritecgarza@hotmail.com",
    "phone": "52-868) 816-2625",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "El Instituto Vida, con más de 30 años de experiencia en el manejo avanzado de parejas infértiles, cuenta con cinco sedes (León, Guadalajara, Matamoros, Mérida",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-dir-instituto-de-fertilidad-humana-ifh-colima",
    "name": "Instituto De Fertilidad Humana (IFH)",
    "address": {
      "id": "addr-mx-dir-instituto-de-fertilidad-humana-ifh-colima",
      "address1": "",
      "address2": null,
      "city": "Colima",
      "state": "COL",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Instituto De Fertilidad Humana (IFH)",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "El Instituto De Fertilidad Humana, también conocido por sus siglas IFH, es un centro de fertilidad del estado mexicano de Colima que cuenta con laboratorio propio. Aquí es posible realizar tratamientos de inseminación artificial fecundación in vitro, congelación de semen, etc.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-143",
    "name": "Instituto IMER - Guadalajara",
    "address": {
      "id": "addr-mx-redlara-143",
      "address1": "Pablo Neruda, 3148 - Colonia Providencia 4a. sección",
      "address2": null,
      "city": "Guadalajara",
      "state": "JAL",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Instituto IMER - Guadalajara",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.institutoimer.com",
    "email": "marielaflores17@hotmail.com",
    "phone": "52-33) 3640-2151",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "IMER Fertility Center es una clínica de reproducción asistida que se encuentra en Guadalajara, la capital de Jalisco. IMER dispone de varios tratamientos de fertilidad para ayudar a sus pacientes a cumplir su sueño y también cuenta con la posibilidad de financiar los costes.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-299",
    "name": "Instituto Ingenes Monterrey",
    "address": {
      "id": "addr-mx-redlara-299",
      "address1": "Av. Revolución, 2703 - Centro Empresarial Nuevo Sur Torre 1, piso 8. Col. Ladrillera",
      "address2": null,
      "city": "Monterrey",
      "state": "NL",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Instituto Ingenes Monterrey",
    "images": [
      {
        "id": "mx-redlara-299-image-1",
        "url": "https://ingenes.com/images/equipo-clinico.jpg",
        "name": "Equipo médico de Ingenes durante un procedimiento"
      },
      {
        "id": "mx-redlara-299-image-2",
        "url": "https://ingenes.com/images/award-eshre.webp",
        "name": "European Society of Human Reproduction and Embryology"
      },
      {
        "id": "mx-redlara-299-image-3",
        "url": "https://ingenes.com/images/og/og-home-es.jpg",
        "name": "Instituto Ingenes Monterrey"
      },
      {
        "id": "mx-redlara-299-image-4",
        "url": "https://ingenes.com/images/20-anos.webp",
        "name": "20 años de Ingenes badge-20"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://ingenes.com",
    "email": "rdrivera@ingenes.com",
    "phone": "52) 8121333100",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "Tasa de éxito #1 en Latinoamérica y 10% más alta que clínicas de EE.UU. 75,000 bebés logrados, 22 sucursales en México y EE.UU. Tu camino empieza acá.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-dir-instituto-mexicano-de-infertilidad-imi-guadalajara",
    "name": "Instituto Mexicano de Infertilidad (IMI)",
    "address": {
      "id": "addr-mx-dir-instituto-mexicano-de-infertilidad-imi-guadalajara",
      "address1": "",
      "address2": null,
      "city": "Guadalajara",
      "state": "JAL",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Instituto Mexicano de Infertilidad (IMI)",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "El Instituto Mexicano de Infertilidad (IMI) está localizado en el Centro Médico Puerta del Hierro de Guadalajara, Jalisco (México). Este centro cuenta con quirófano y laboratorio propio para llevar a cabo los tratamientos de fertilidad ofrecidos a sus pacientes. Su director médico es el Dr. Arturo Ruvalcaba.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-121",
    "name": "Instituto VIDA - León",
    "address": {
      "id": "addr-mx-redlara-121",
      "address1": "Plaza las Américas 115 - Colonia Jardínes del Moral",
      "address2": null,
      "city": "Leon",
      "state": "GTO",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Instituto VIDA - León",
    "images": [
      {
        "id": "mx-redlara-121-image-1",
        "url": "https://www.institutovida.com/images/slider-2.jpg",
        "name": "... d-block w-100"
      },
      {
        "id": "mx-redlara-121-image-2",
        "url": "https://www.institutovida.com/images/slider-3.jpg",
        "name": "... d-block w-100"
      },
      {
        "id": "mx-redlara-121-image-3",
        "url": "https://www.institutovida.com/images/slider.png",
        "name": "... d-block w-100"
      },
      {
        "id": "mx-redlara-121-image-4",
        "url": "https://www.institutovida.com/images/AN_Foto-14%201.jpg",
        "name": "Image sppb-img-responsive"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.institutovida.com",
    "email": "gonclau7@yahoo.com.mx",
    "phone": "52 (477) 779-0835",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "El Instituto Vida, con más de 30 años de experiencia en el manejo avanzado de parejas infértiles, cuenta con cinco sedes (León, Guadalajara, Matamoros, Mérida",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-114",
    "name": "Instituto Vida Guadalajara (Instituto de Ciencias en Reproducción Humana)",
    "address": {
      "id": "addr-mx-redlara-114",
      "address1": "Av. Empresarios 150, Planta Baja 6, Col.Puerta de Hierro, Zapopan, Jalisco",
      "address2": null,
      "city": "Guadalajara",
      "state": "JAL",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Instituto Vida Guadalajara (Instituto de Ciencias en Reproducción Humana)",
    "images": [
      {
        "id": "mx-redlara-114-image-1",
        "url": "https://www.institutovida.com/images/slider-2.jpg",
        "name": "... d-block w-100"
      },
      {
        "id": "mx-redlara-114-image-2",
        "url": "https://www.institutovida.com/images/slider-3.jpg",
        "name": "... d-block w-100"
      },
      {
        "id": "mx-redlara-114-image-3",
        "url": "https://www.institutovida.com/images/slider.png",
        "name": "... d-block w-100"
      },
      {
        "id": "mx-redlara-114-image-4",
        "url": "https://www.institutovida.com/images/AN_Foto-14%201.jpg",
        "name": "Image sppb-img-responsive"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.institutovida.com/public_htm/",
    "email": "consultainstitutovida@hotmail.com",
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "El Instituto Vida, con más de 30 años de experiencia en el manejo avanzado de parejas infértiles, cuenta con cinco sedes (León, Guadalajara, Matamoros, Mérida",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-260",
    "name": "Instituto Vida Merida",
    "address": {
      "id": "addr-mx-redlara-260",
      "address1": "Calle 21 # 204-D entre 24 y 26, Colonia Garcia Gineres",
      "address2": null,
      "city": "Merida",
      "state": "YUC",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Instituto Vida Merida",
    "images": [
      {
        "id": "mx-redlara-260-image-1",
        "url": "https://institutovidamerida.com.mx/img/master/index/agenda-doctor.png",
        "name": "Instituto Vida Merida"
      },
      {
        "id": "mx-redlara-260-image-2",
        "url": "https://institutovidamerida.com.mx/uploads/banners/74-cover-julio-web-2020.png",
        "name": "Instituto Vida Merida"
      },
      {
        "id": "mx-redlara-260-image-3",
        "url": "https://institutovidamerida.com.mx/uploads/banners/85-instituto-vida-banner-jpg-marzo-2021.jpeg",
        "name": "Instituto Vida Merida"
      },
      {
        "id": "mx-redlara-260-image-4",
        "url": "https://institutovidamerida.com.mx/img/master/layout/banner-cita.png",
        "name": "Instituto Vida Merida"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.institutovidamerida.com.mx",
    "email": "contacto@institutovidamerida.com.mx",
    "phone": "52-999) 925-2120",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "Instituto Vida es un centro de fertilidad que cuenta con varias sedes (Mérida, Tijuana, Matamoros, Querétaro, Guadalajara, Ciudad de México y León). En concreto, Instituto Vida Mérida dispone de las instalaciones necesarias para llevar a cabo los tratamientos de fertilidad disponibles.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-197",
    "name": "Instituto Vida Tijuana",
    "address": {
      "id": "addr-mx-redlara-197",
      "address1": "Paseo de los Heroes, 10289, int. 7003 piso 7, Zona Urbana Rio",
      "address2": null,
      "city": "Tijuana",
      "state": "BC",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Instituto Vida Tijuana",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": "admonvidanoroeste@outlook.com",
    "phone": "52-664) 9766444",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-liv-fertility-center-nuevo-vallarta",
    "name": "LIV Fertility Center",
    "address": {
      "id": "addr-mx-dir-liv-fertility-center-nuevo-vallarta",
      "address1": "",
      "address2": null,
      "city": "Nuevo Vallarta",
      "state": "NAY",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "LIV Fertility Center",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Mexico clinic directory listing; street address should be verified in a later enrichment pass.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-343",
    "name": "MásFértil",
    "address": {
      "id": "addr-mx-redlara-343",
      "address1": "Juan B. Ceballos, 487 - Nueva Chapultepec",
      "address2": null,
      "city": "Morelia",
      "state": "MICH",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "MásFértil",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": "rp@masfertil.mx",
    "phone": "+52 443-3246600",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "MásFértil es una clínica de fertilidad de entidad privada que se encuentra en la ciudad de Morelia, en el estado mexicano de Michoacán. Este centro de fertilidad realiza diversos tratamientos de fertilidad y ofrece la posibilidad de financiación para que el pago sea más fácil.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-mtr-fertility-hermosillo",
    "name": "MTR Fertility",
    "address": {
      "id": "addr-mx-dir-mtr-fertility-hermosillo",
      "address1": "",
      "address2": null,
      "city": "Hermosillo",
      "state": "SON",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "MTR Fertility",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "La clínica de fertilidad MTR Fertility está integrada dentro del hospital San José de Hermosillo, Sonora. Este centro de fertilidad cuenta con las instalaciones necesarias para llevar a cabo los tratamientos de fertilidad ofrecidos a sus pacientes.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-neorigen-mazatlan",
    "name": "Neorigen - Mazatlán",
    "address": {
      "id": "addr-mx-dir-neorigen-mazatlan",
      "address1": "",
      "address2": null,
      "city": "Mazatlán",
      "state": "SIN",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Neorigen - Mazatlán",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Neorigen es un centro médico que cuenta con tres sedes repartidas por México, aunque solo la clínica de Guadalajara (Jalisco) y la de Mazatlán (Sinaloa) son las únicas que ofrecen servicios de fertilidad.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-neorigen-tijuana",
    "name": "Neorigen - Tijuana",
    "address": {
      "id": "addr-mx-dir-neorigen-tijuana",
      "address1": "",
      "address2": null,
      "city": "Tijuana",
      "state": "BC",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Neorigen - Tijuana",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Neorigen es un centro médico que cuenta con tres sedes repartidas por México, aunque solo la clínica de Guadalajara (Jalisco) y la de Mazatlán (Sinaloa) son las únicas que ofrecen servicios de fertilidad.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-neorigen-zapopan",
    "name": "Neorigen - Zapopan",
    "address": {
      "id": "addr-mx-dir-neorigen-zapopan",
      "address1": "",
      "address2": null,
      "city": "Zapopan",
      "state": "JAL",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Neorigen - Zapopan",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "Neorigen es un centro médico que cuenta con tres sedes repartidas por México, aunque solo la clínica de Guadalajara (Jalisco) y la de Mazatlán (Sinaloa) son las únicas que ofrecen servicios de fertilidad.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-329",
    "name": "Origen MX Fertilidad y Salud Reproductiva",
    "address": {
      "id": "addr-mx-redlara-329",
      "address1": "Calle 15, #501, entre 18 y 22, piso 11 - Penthouse. Frac. Altabrisa",
      "address2": null,
      "city": "Merida",
      "state": "YUC",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Origen MX Fertilidad y Salud Reproductiva",
    "images": [
      {
        "id": "mx-redlara-329-image-1",
        "url": "https://www.centroorigen.com.mx/imagenes/promocion_pop.jpg",
        "name": "Origen MX Fertilidad y Salud Reproductiva"
      },
      {
        "id": "mx-redlara-329-image-2",
        "url": "https://www.centroorigen.com.mx/imagenes/pcs_inicio.jpg",
        "name": "Origen MX Fertilidad y Salud Reproductiva"
      },
      {
        "id": "mx-redlara-329-image-3",
        "url": "https://www.centroorigen.com.mx/imagenes/pic_a.jpg",
        "name": "Origen MX Fertilidad y Salud Reproductiva"
      },
      {
        "id": "mx-redlara-329-image-4",
        "url": "https://www.centroorigen.com.mx/imagenes/pic_b.jpg",
        "name": "Origen MX Fertilidad y Salud Reproductiva"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.centroorigen.com.mx/",
    "email": "citas@centroorigen.com.mx",
    "phone": "+52 999 400 8200",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-301",
    "name": "Plenus Reproducción Asistida",
    "address": {
      "id": "addr-mx-redlara-301",
      "address1": "Lago Zurich, 219 int, 402-A, 4º piso. Col. Granada",
      "address2": null,
      "city": "Ciudad de México",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Plenus Reproducción Asistida",
    "images": [
      {
        "id": "mx-redlara-301-image-1",
        "url": "https://www.plenusmedical.com/images/slider-banner/banner-1.jpg",
        "name": "Plenus Reproducción Asistida"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.plenusmedical.com",
    "email": "atencionpacientes@plenusmedical.com",
    "phone": "+52-55-91302100",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "La clínica Plenus localizada en la Ciudad de México realiza diversas técnicas de reproducción asistida y también ofrece servicio de gestación subrogada. Sin embargo, no se conocen experiencias de esta clínica de fertilidad.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-dir-procrea-mexico-city",
    "name": "PROCREA - Mexico City",
    "address": {
      "id": "addr-mx-dir-procrea-mexico-city",
      "address1": "",
      "address2": null,
      "city": "Mexico City",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "PROCREA - Mexico City",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "PROCREAR es un centro de reproducción asistida de México que cuenta con sedes en Ciudad de México y en Puebla. Este centro cuenta con un equipo multidisciplinar y ofrecen a sus pacientes diversos servicios.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-procrea-san-andres-cholula",
    "name": "PROCREA - San Andrés Cholula",
    "address": {
      "id": "addr-mx-dir-procrea-san-andres-cholula",
      "address1": "",
      "address2": null,
      "city": "San Andrés Cholula",
      "state": "PUE",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "PROCREA - San Andrés Cholula",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "PROCREAR es un centro de reproducción asistida de México que cuenta con sedes en Ciudad de México y en Puebla. Este centro cuenta con un equipo multidisciplinar y ofrecen a sus pacientes diversos servicios.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-256",
    "name": "PROGEN",
    "address": {
      "id": "addr-mx-redlara-256",
      "address1": "Av. Francisco Garcia Salinas, 19 Col El Carmen",
      "address2": null,
      "city": "Guadalupe",
      "state": "ZAC",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "PROGEN",
    "images": [
      {
        "id": "mx-redlara-256-image-1",
        "url": "https://www.progenzac.com/img/avatar-1.png",
        "name": "PROGEN"
      },
      {
        "id": "mx-redlara-256-image-2",
        "url": "https://www.progenzac.com/img/avatar-2.png",
        "name": "PROGEN"
      },
      {
        "id": "mx-redlara-256-image-3",
        "url": "https://www.progenzac.com/img/avatar-3.png",
        "name": "PROGEN"
      },
      {
        "id": "mx-redlara-256-image-4",
        "url": "https://www.progenzac.com/img/avatar-4.png",
        "name": "PROGEN"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.progenzac.com",
    "email": "contacto@progenzac.com",
    "phone": "52-492) 899-4900",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-198",
    "name": "Red Crea Fertilidad",
    "address": {
      "id": "addr-mx-redlara-198",
      "address1": "Managua, 730 - Lindavista",
      "address2": null,
      "city": "Ciudad de México",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Red Crea Fertilidad",
    "images": [
      {
        "id": "mx-redlara-198-image-1",
        "url": "https://redcrea.com.mx/wp-content/plugins/translatepress-multilingual/assets/images/flags/en_US.png",
        "name": "en_US English trp-flag-image"
      },
      {
        "id": "mx-redlara-198-image-2",
        "url": "https://redcrea.com.mx/wp-content/uploads/elementor/thumbs/1-r7bu12uxmwx0tsjw41ltqgpm8a4x91886vohdcvyxs.jpg",
        "name": "Red Crea Fertilidad"
      },
      {
        "id": "mx-redlara-198-image-3",
        "url": "https://redcrea.com.mx/wp-content/uploads/elementor/thumbs/2-r7bu18hyrx4qrgbp741l5fadsld4j7um7nle90nlwg.jpg",
        "name": "Red Crea Fertilidad"
      },
      {
        "id": "mx-redlara-198-image-4",
        "url": "https://redcrea.com.mx/wp-content/uploads/elementor/thumbs/FAMILIA-RED-CREA-GALERIA-21-r7gn3fhjak4bad2oh5vx2oa0l0temc00b6do04xt40.jpeg",
        "name": "FAMILIA-RED-CREA-GALERIA (21) FAMILIA-RED-CREA-GALERIA (21)"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://redcrea.com.mx",
    "email": "informes@redcrea.com.mx",
    "phone": "52-55) 5752-1234",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "En Red Crea, llevamos más de 30 años acompañando historias de vida y construyendo sueños cumplidos.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-296",
    "name": "Red Génesis Centros de Fertilidad",
    "address": {
      "id": "addr-mx-redlara-296",
      "address1": "Clarion 1434, Isla Musala",
      "address2": null,
      "city": "Culiacán",
      "state": "SIN",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Red Génesis Centros de Fertilidad",
    "images": [
      {
        "id": "mx-redlara-296-image-1",
        "url": "https://www.redgenesis.mx/web/image/3802-2d5e041b/IMG_0521-1.PNG",
        "name": "img img-fluid mx-auto o_we_custom_image"
      },
      {
        "id": "mx-redlara-296-image-2",
        "url": "https://www.redgenesis.mx/web/image/3133-1918caa9/035.jpg",
        "name": "img img-fluid mx-auto o_we_custom_image"
      },
      {
        "id": "mx-redlara-296-image-3",
        "url": "https://www.redgenesis.mx/web/image/3135-fbe29ef9/081.jpg",
        "name": "img img-fluid mx-auto o_we_custom_image"
      },
      {
        "id": "mx-redlara-296-image-4",
        "url": "https://www.redgenesis.mx/web/image/3134-bbf01076/044.jpg",
        "name": "img img-fluid mx-auto o_we_custom_image"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "http://www.redgenesis.mx/",
    "email": "informes@redgenesis.mx",
    "phone": "52 (667) 7166645",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "RED GÉNESIS es un centro de reproducción asistida de México, que cuenta con dos sedes ubicadas ambas en Sinaloa. Este centro ofrece diferentes tratamientos de reproducción asistida, así como ciertas técnicas complementarias.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-315",
    "name": "REPROGYN - Centro de Cirugía Reproductiva y Ginecología",
    "address": {
      "id": "addr-mx-redlara-315",
      "address1": "Prolongación Usamacinta, 2085 suite 840. Torre de Consultorios - Hospital Angeles",
      "address2": null,
      "city": "Villahermosa",
      "state": "TAB",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "REPROGYN - Centro de Cirugía Reproductiva y Ginecología",
    "images": [
      {
        "id": "mx-redlara-315-image-1",
        "url": "https://static.wixstatic.com/media/4102f8_2958e9d262c04cc9b3d35a34a195d465%7Emv2.png/v1/fit/w_2500,h_1330,al_c/4102f8_2958e9d262c04cc9b3d35a34a195d465%7Emv2.png",
        "name": "REPROGYN - Centro de Cirugía Reproductiva y Ginecología"
      },
      {
        "id": "mx-redlara-315-image-2",
        "url": "https://static.wixstatic.com/media/de0ab0f76d13a91e5833714f80c1dc3d.jpg/v1/fill/w_460,h_340,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/de0ab0f76d13a91e5833714f80c1dc3d.jpg",
        "name": "gRkIq0 sFiSiq"
      },
      {
        "id": "mx-redlara-315-image-3",
        "url": "https://static.wixstatic.com/media/4102f8_b9a13341a7c64e2080bab5e2a3f96f47~mv2.jpg/v1/fill/w_460,h_340,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/4102f8_b9a13341a7c64e2080bab5e2a3f96f47~mv2.jpg",
        "name": "gRkIq0 sFiSiq"
      },
      {
        "id": "mx-redlara-315-image-4",
        "url": "https://static.wixstatic.com/media/679ee876606940af9690fef707686081.jpg/v1/fill/w_460,h_340,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/679ee876606940af9690fef707686081.jpg",
        "name": "gRkIq0 sFiSiq"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.reprogyn.com.mx",
    "email": "rcabra@reprogyn.com.mx",
    "phone": "+52-9933100433",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "Reprogyn es un centro de fertilidad ubicado en la ciudad de Villahermosa, perteneciente al estado mexicano de Tabasco. Su director médico es el Dr. Cabra y ofrece servicios de reproducción asistida, ginecología y obstetricia. Además, el centro también dispone de servicio de cirugía reproductiva.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-redlara-115",
    "name": "Unidad de Reproducción Humana y Genética",
    "address": {
      "id": "addr-mx-redlara-115",
      "address1": "Av.Pedro Rosales de León, 7510 - Frac. Fuentes del Valle - Hosp. Poliplaza Médica",
      "address2": null,
      "city": "Ciudad Juarez",
      "state": "CHIH",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Unidad de Reproducción Humana y Genética",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": "urhuge.ppm@gmail.com",
    "phone": "52 (656) 6180598",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-341",
    "name": "UNILIVE. Unidad de Fertilidad y Esterilidad Puebla",
    "address": {
      "id": "addr-mx-redlara-341",
      "address1": "Blvd. Atlixcayotl, 1499 Interior 13 - Edif. Valcob - San Andrés Cholula",
      "address2": null,
      "city": "Puebla",
      "state": "PUE",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "UNILIVE. Unidad de Fertilidad y Esterilidad Puebla",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": "gabriela.garcia@unilive.com.mx",
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "El centro de reproducción asistida UNILIVE del estado mexicano de Puebla cuenta con laboratorio propio para llevar a cabo todos los tratamientos de fertilidad ofrecidos a sus pacientes.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-dir-ur-crea-mexico-mexico-city",
    "name": "UR Crea México - Mexico City",
    "address": {
      "id": "addr-mx-dir-ur-crea-mexico-mexico-city",
      "address1": "",
      "address2": null,
      "city": "Mexico City",
      "state": "CDMX",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "UR Crea México - Mexico City",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "UR Crea México es un centro de reproducción asistida en México que cuenta con dos sedes, UR Crea Norte y UR Crea Sur, ambas en Ciudad de México. Este centro pertenece al grupo UR y cuenta con un equipo multidisciplinar que ofrece a sus pacientes diferentes tratamientos de reproducción asistida.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-159",
    "name": "URA - Hospital CIMA Hermosillo",
    "address": {
      "id": "addr-mx-redlara-159",
      "address1": "Paseo Rio San Miguel, 35, Colonia Río Sonora",
      "address2": null,
      "city": "Hermosillo",
      "state": "SON",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "URA - Hospital CIMA Hermosillo",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.ura.mx",
    "email": "jmojarra@icloud.com",
    "phone": "52 (662) 212-6960",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "REDLARA member center.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  },
  {
    "id": "mx-dir-vefertil-leon-de-los-aldama",
    "name": "Vefértil",
    "address": {
      "id": "addr-mx-dir-vefertil-leon-de-los-aldama",
      "address1": "",
      "address2": null,
      "city": "León de los Aldama",
      "state": "GTO",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "Vefértil",
    "images": [],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": null,
    "email": null,
    "phone": null,
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": null,
    "lastReportYear": 2026,
    "publicNotes": "La clínica de fertilidad Vefértil está ubicada en la ciudad de León de los Aldama, en el estado mexicano de Guanajuato. Aquí trabaja un equipo multidisciplinar de profesionales compuesto por biólogos y ginecólogos con una larga trayectoria.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": false
  },
  {
    "id": "mx-redlara-349",
    "name": "ViaFERT Clínica de Fertilidad en Sinaloa",
    "address": {
      "id": "addr-mx-redlara-349",
      "address1": "Mariano Escobedo # 185, Primer Cuadro (dentro de Polimédica Laboratorios CUEN",
      "address2": null,
      "city": "Culiacán",
      "state": "SIN",
      "postalCode": "",
      "country": "MX"
    },
    "headline": "ViaFERT Clínica de Fertilidad en Sinaloa",
    "images": [
      {
        "id": "mx-redlara-349-image-1",
        "url": "https://i0.wp.com/viafert.com/wp-content/uploads/2022/12/PortaFace_ViaFert1-1.jpg?resize=1080%2C608&ssl=1",
        "name": "Mapa y datos de contacto de ViaFERT Culiacán Mapa y datos de contacto de ViaFERT Culiacán wp-image-462"
      },
      {
        "id": "mx-redlara-349-image-2",
        "url": "https://i0.wp.com/viafert.com/wp-content/uploads/2025/06/imagen-5.png?resize=1080%2C1080&ssl=1",
        "name": "imagen (5) wp-image-9557"
      },
      {
        "id": "mx-redlara-349-image-3",
        "url": "https://i0.wp.com/viafert.com/wp-content/uploads/2025/02/CROQUIS-VIAFERT-MAZ.jpg?w=1080&ssl=1",
        "name": "CROQUIS VIAFERT - MAZ"
      }
    ],
    "tags": [],
    "services": [],
    "languages": ["es"],
    "clinicType": "Boutique",
    "conditions": [],
    "treatments": [
      "IVF & ICSI",
      "IUI",
      "Egg Freezing",
      "Sperm Freezing",
      "Embryo Freezing"
    ],
    "website": "https://www.viafert.com",
    "email": "informes@viafert.com",
    "phone": "+52 667 4295052",
    "bookingUrl": null,
    "location": null,
    "insurances": [],
    "insuranceAccepted": false,
    "insuranceName": null,
    "financiers": [],
    "consultationTypes": [],
    "patientGroups": [],
    "accessibilities": [],
    "employeeBenefits": [],
    "openingTime": null,
    "closingTime": null,
    "isFirstConsultationFree": false,
    "hasReportedAnnualIvfData": false,
    "nbCyclePerYear": null,
    "reportedTo": "REDLARA",
    "outcomeSourceType": "registry-participation",
    "lastReportYear": 2026,
    "publicNotes": "La clínica de fertilidad ViaFERT se encuentra en la ciudad de Culiacán (Sinaloa, México) y cuenta con laboratorio y quirófano. Además, este centro ofrece la posibilidad de hacer tratamientos a distancia y servicio de gestación subrogada.",
    "lastUpdatedIso": "2026-06-14T00:00:00.000Z",
    "successRates": {},
    "newPatientSuccessRates": {},
    "donorSuccessRates": {},
    "medicaldirector": null,
    "clinicStatus": null,
    "isRecordComplete": true
  }
]
